export default __webpack_public_path__ + "static/media/38.923b8fe5.jpeg";